/** Matches any Han-script code point (Unicode `Script=Han`). */
export const HANIVERSE_SCRIPT_REGEX = /\p{Script=Han}/u;

/** True if `value` contains at least one Han-script code point. */
export function hasHanScript(value: string): boolean {
  return HANIVERSE_SCRIPT_REGEX.test(value);
}
